export enum SessionStatus {
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
}

export type SessionStateLoggedIn = {
  status: SessionStatus.LOGGED_IN;
  token: string;
  permissions: Array<string>;
  selectedOrganizationId: string;
  userDetails: {
    email: string;
    name: string;
    picture: string;
  } | null;
};

export type SessionStateLoggedOut = { status: SessionStatus.LOGGED_OUT };

export type SessionState = SessionStateLoggedIn | SessionStateLoggedOut;

export enum SessionActionTypes {
  SESSION_SET_TOKEN = 'SESSION_SET_TOKEN',
  SESSION_CLEAR_TOKEN = 'SESSION_CLEAR_TOKEN',
  SESSION_SET_SELECTED_ORGANIZATION_ID = 'SESSION_SET_SELECTED_ORGANIZATION_ID',
  SESSION_SET_USER_DETAILS = 'SESSION_SET_USER_DETAILS',
}

export type SessionAction =
  | {
      type: SessionActionTypes.SESSION_SET_SELECTED_ORGANIZATION_ID;
      id: string;
    }
  | { type: SessionActionTypes.SESSION_SET_TOKEN; token: string }
  | { type: SessionActionTypes.SESSION_CLEAR_TOKEN }
  | {
      type: SessionActionTypes.SESSION_SET_USER_DETAILS;
      email: string;
      name: string;
      picture: string;
    };
